<script setup lang="ts">
import { useRepositories } from '../utils/useRepositories'

import {
  DSDropdownMenu,
  DSDropdownMenuContent,
  DSDropdownMenuItem,
  DSDropdownMenuLabel,
  DSDropdownMenuSeparator,
  DSDropdownMenuTrigger,
  DSInputGroup,
  DSInputGroupAddon,
  DSInputGroupInput,
} from '@ds'
import { CheckIcon, FolderGit2Icon, PlusIcon, SearchIcon, Settings2Icon } from '@lucide/vue'

const { query, name, owner, repositories, handleSelect, handleCreate, handleManage } = useRepositories()
</script>

<template>
  <DSDropdownMenu>
    <DSDropdownMenuTrigger as-child>
      <slot
        :repository-name="name"
        :repository-owner="owner"
      />
    </DSDropdownMenuTrigger>
    <DSDropdownMenuContent
      align="start"
      class="w-75 rounded-ds-lg p-0 overflow-hidden"
    >
      <div class="p-2.5 border-b border-border">
        <DSInputGroup>
          <DSInputGroupAddon>
            <SearchIcon class="size-4.5" />
          </DSInputGroupAddon>
          <DSInputGroupInput
            v-model="query"
            type="search"
            placeholder="Find a repository"
            aria-label="Find a repository"
          />
        </DSInputGroup>
      </div>
      <div class="p-1.5 max-h-80 overflow-y-auto">
        <DSDropdownMenuLabel>Repositories</DSDropdownMenuLabel>
        <DSDropdownMenuItem
          v-for="repository in repositories"
          :key="repository.id"
          class="h-10"
          :class="repository.active && 'bg-accent text-accent-foreground'"
          @select="handleSelect(repository.id)"
        >
          <FolderGit2Icon
            class="size-4"
            aria-hidden="true"
          />
          <span class="flex-1 truncate">{{ repository.name }}</span>
          <CheckIcon
            v-if="repository.active"
            class="size-4 text-brand"
            aria-hidden="true"
          />
        </DSDropdownMenuItem>
      </div>
      <DSDropdownMenuSeparator class="my-0" />
      <div class="p-1.5">
        <DSDropdownMenuItem
          class="h-9.5 text-brand font-semibold"
          @select="handleCreate"
        >
          <PlusIcon
            class="size-4"
            aria-hidden="true"
          />
          New repository
        </DSDropdownMenuItem>
        <DSDropdownMenuItem
          class="h-9.5"
          @select="handleManage"
        >
          <Settings2Icon
            class="size-4"
            aria-hidden="true"
          />
          Manage repositories
        </DSDropdownMenuItem>
      </div>
    </DSDropdownMenuContent>
  </DSDropdownMenu>
</template>
